import script from "./CompanyContactListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyContactListView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyContactListView.vue?vue&type=style&index=0&id=2adb683d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2adb683d"]])

export default __exports__